export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://wakiliapi.samis.co.ke'

async function parseError(response) {
  try {
    const data = await response.json()
    if (data.message) return data.message
    if (data.error) return data.error
  } catch {
    // ignore parse errors
  }
  return response.statusText || 'Request failed'
}

const PUBLIC_ADMIN_PATHS = ['/admin/auth/signin', '/admin/auth/register']

function isAdminPath(path) {
  return path.startsWith('/admin/') && !PUBLIC_ADMIN_PATHS.some((p) => path.startsWith(p))
}

export async function apiRequest(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  }

  if (!options.skipAuth) {
    const useAdminAuth = options.useAdminAuth ?? isAdminPath(path)
    const tokenKey = useAdminAuth ? 'adminToken' : 'token'
    const token = localStorage.getItem(tokenKey)
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  })

  if (!response.ok) {
    const message = await parseError(response)
    const error = new Error(message)
    error.status = response.status
    throw error
  }

  if (response.status === 204) {
    return null
  }

  return response.json()
}

function authHeaders(options = {}) {
  const headers = { ...options.headers }

  if (!options.skipAuth) {
    const useAdminAuth = options.useAdminAuth ?? isAdminPath(options.path || '')
    const tokenKey = useAdminAuth ? 'adminToken' : 'token'
    const token = localStorage.getItem(tokenKey)
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }
  }

  return headers
}

export async function apiMultipartRequest(path, formData, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    ...options,
    headers: authHeaders({ ...options, path }),
    body: formData,
  })

  if (!response.ok) {
    const message = await parseError(response)
    const error = new Error(message)
    error.status = response.status
    throw error
  }

  if (response.status === 204) {
    return null
  }

  return response.json()
}

export async function apiBlobRequest(path, options = {}) {
  const headers = authHeaders({ ...options, path })

  if (options.body && typeof options.body === 'string' && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: options.method || 'POST',
    ...options,
    headers,
  })

  if (!response.ok) {
    const message = await parseError(response)
    const error = new Error(message)
    error.status = response.status
    throw error
  }

  return response.blob()
}
